import type { PublicNavContext } from "../publicNavigation";
import type { NavConfig } from "./types";

export function getTrustNavConfig(ctx: PublicNavContext): NavConfig["trust"] {
  const { isSwedish } = ctx;
  return {
    label: isSwedish ? "Trygghet" : "Trust",
    overview: isSwedish ? "/trygghet" : "/en/trust",
    submenu: {
      overview: {
        label: isSwedish ? "Trygghetscenter" : "Trust center",
        href: isSwedish ? "/trygghet" : "/en/trust",
        description: isSwedish
          ? "Lagring, åtkomst, AI, underbiträden och dokument"
          : "Storage, access, AI, subprocessors and documents",
      },
      // Owner 2026-10-25: one link. The trust center holds the DPA, privacy
      // policy, terms, security help and the EU AI Act notes.
      items: [],
    },
  };
}
